import { Fragment } from "react";
import { Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";

export default function Alert({ alert, setAlert, message }) {
  const {t} = useTranslation();

  return (
    <>
      {alert && (
        <div
          aria-live="assertive"
          className="relative inset-0 bottom-20 lg:bottom-32 flex items-center px-4 py-6 pointer-events-none sm:p-6"
        >
          <div className="w-full flex flex-col items-center space-y-4 ">
            <Transition
              show={alert}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-red-400 shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div className="p-4">
                  <div className="flex items-center">
                    <div className="w-0 flex-1 flex justify-between">
                      <p className="w-0 flex-1 text-sm font-medium text-gray-900">
                        {message}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      )}
    </>
  );
}
